import { createReducer }    from 'immutable-reducers';
import { userRoles }        from 'app/access';
import { Map, fromJS }      from 'immutable';
import browserStore         from 'store';

import {LOGIN, LOGOUT} from '../constants/actionTypes';

export const authReducer = (auth = {}, action) => {

    switch (action.type) {
        case LOGIN.REQUEST:
            return Object.assign({}, auth, {
                isAuthenticating: true
            });
        case LOGIN.SUCCESS:
            // :( reducers should be pure
            browserStore.set('token', action.jwt);
            browserStore.set('sessionData', action.sessionData);

            return Object.assign({}, auth, {
                isAuthenticating: false,
                isAuthenticated: true,
                token: action.jwt,
                userName: action.sessionData.username,
                accessLvl: userRoles.user,
                statusText: null,
                errorCode: null,
                errorId: null
            });
        case LOGIN.ERROR:
            // :( reducers should be pure
            browserStore.remove('token');
            browserStore.remove('sessionData');

            return Object.assign({}, auth, {
                isAuthenticating: false,
                isAuthenticated: false,
                token: null,
                userName: null,
                statusText: action.error.response.statusText,
                errorCode: action.error.response.statusCode,
                errorId: action.error.body && action.error.body.errors ? action.error.body.errors[0].code : '500'
            });
        case LOGOUT:
            // :( reducers should be pure
            browserStore.remove('token');
            browserStore.remove('sessionData');

            return Object.assign({}, auth, {
                isAuthenticated: false,
                token: null,
                userName: null,
                accessLvl: userRoles.public
            });
        default:
            break;
    }
    return auth;
};

export default createReducer(['auth'], authReducer);
